
import { defineComponent } from 'vue'
import Button from '@/components/Button/index.vue'
export default defineComponent({
  emits: [],
  components: { Button },
  name: 'Template',
  props: {
    type: {
      type: Number,
      default: 0
    }
  },
  setup(props, { emit }) {
    function signin() {
      window.MobileApp.call('onSignIn_Test', 'onSignIn')
    }
    function signout() {
      window.MobileApp.call('onSignOut_Test', 'onSignOut')
    }
    function shareInfo() {
      window.MobileApp.call('shareInfo_Test', 'shareInfo')
    }
    return {
      signin,
      signout,
      shareInfo
    }
  }
})
